<!--
  - Copyright (c) Interactive Information R & D (I2RD) LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - I2RD LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with I2RD.
  -->
<template>
  <!--Intentionally empty, otherwise vue throws console errors-->
  <pre />
</template>
<script>
import { get } from "@/services/request";
import { vendorInfoAPI } from "@/services/api";

export default {
  name: "IncompleteProofOfMonitoringRedirector",
  props: ["checklistItemId", "customerId"],

  created() {
    const employeeMonitoringRoute = {
      name: "showProofOfEmployeeMonitoring",
      params: {
        checklistItemId: this.checklistItemId,
        customerId: this.customerId
      }
    };

    get(vendorInfoAPI)
      .then(response => {
        if (response && response.data) {
          this.vendor = response.data;

          const employeeMonitoringInfo = this.vendor.monitoringInfos.find(
            info => info.type === "EMPLOYEE_MONITORING"
          );
          if (
            employeeMonitoringInfo?.startDate != null &&
            employeeMonitoringInfo?.numberOfEntities == 0
          ) {
            this.$router.replace({
              name: "addEmployees"
            });
          } else {
            this.$router.replace(employeeMonitoringRoute);
          }
        } else {
          throw new Error("No response from Vendor Info API");
        }
      })
      .catch(error => {
        console.error(
          "Failed to get Vendor Info, redirecting to default path ",
          error
        );
        this.$router.replace(employeeMonitoringRoute);
      });
  }
};
</script>
